
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetohyderbadbus() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Bus On Rent',
        heading: 'Amruta Travels: Pune to Hyderabad Bus On Rent',
        headingDescription: 'Amruta Travels offers Pune to Hyderabad Bus On Rent, providing a reliable and comfortable transportation solution for your journey to the vibrant city of Hyderabad. Whether you are planning a family trip, corporate event, or group tour, our well-maintained buses ensure a smooth and enjoyable ride. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your Pune to Hyderabad travel simple and stress-free. Book your bus with Amruta Travels and embark on a journey of comfort and discovery!',


        top: 'Top Places to Visit in Hyderabad with Amruta Travels',
"topPlaces": [
  {
    "title": "Charminar",
    "description": "Built in 1591 by Muhammad Quli Qutb Shah, Charminar is Hyderabad's most iconic monument. This grand structure features four towering minarets and is surrounded by bustling bazaars like Laad Bazaar, known for its bangles and pearls. The monument stands as a testament to Indo-Islamic architecture and is a must-visit for history enthusiasts."
  },
  {
    "title": "Golconda Fort",
    "description": "Once the capital of the medieval Golconda Sultanate, Golconda Fort is renowned for its acoustics, palaces, and ingenious water supply system. The fort offers panoramic views of Hyderabad and is famous for its evening sound and light show that narrates its rich history."
  },
  {
    "title": "Ramoji Film City",
    "description": "Spanning over 2,500 acres, Ramoji Film City holds the Guinness World Record for being the largest film studio complex globally. It offers guided tours, film sets, amusement parks, and live shows, making it a favorite among tourists and film enthusiasts."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Commissioned in 1563, this heart-shaped lake connects Hyderabad and Secunderabad. At its center stands a 18-meter tall monolithic statue of Lord Buddha. The lake is surrounded by attractions like Lumbini Park and offers boating facilities for visitors."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Home to one of the largest one-man collections of antiques in the world, the Salar Jung Museum showcases artifacts from various civilizations. Highlights include the Veiled Rebecca statue and a vast collection of manuscripts, paintings, and sculptures."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Once the seat of the Asaf Jahi dynasty, this 18th-century palace complex reflects the grandeur of the Nizams. With its elegant courtyards, ornate halls, and vintage car collection, it offers a glimpse into royal life."
  },
  {
    "title": "Birla Mandir",
    "description": "Constructed entirely of white marble, Birla Mandir is dedicated to Lord Venkateswara. Perched atop a hill, it provides panoramic views of the city and is a serene spot for spiritual seekers."
  },
  {
    "title": "Mecca Masjid",
    "description": "One of the oldest mosques in Hyderabad, Mecca Masjid was built using bricks from Mecca, lending it its name. The mosque can accommodate over 10,000 worshippers and stands as a symbol of the city's Islamic heritage."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Spread over 380 acres, this zoo houses a diverse range of fauna, including tigers, elephants, and reptiles. It offers safari rides and is a popular destination for families and wildlife enthusiasts."
  },
  {
    "title": "Laad Bazaar",
    "description": "Adjacent to Charminar, Laad Bazaar is a vibrant market known for its exquisite bangles, pearls, and traditional Hyderabadi attire. The narrow lanes are filled with shops offering a plethora of handcrafted items."
  }
],



  "services": [
    {
      "name": "Pune to Mysore Ooty Bus Package on Rent",
      "description": "Experience the beauty of Mysore and Ooty with Amruta Travels' Pune to Mysore Ooty Bus Package. We offer comfortable buses for both small and large groups, providing scenic views and a relaxing journey. The package includes sightseeing, hotel accommodations, and safe travel to these popular hill stations."
    },
    {
      "name": "Pune to Tirupati Balaji Bus on Hire",
      "description": "Travel to the holy city of Tirupati for a divine experience with Amruta Travels’ Pune to Tirupati Balaji bus hire services. Our well-maintained buses ensure comfort and safety for your spiritual journey, complete with experienced drivers and timely arrivals."
    },
    {
      "name": "Pune to Tirupati Bus Package",
      "description": "Join our Pune to Tirupati bus package for a seamless pilgrimage to the sacred Tirumala temple. This package includes comfortable bus travel, guided darshan tours, and hotel accommodation for a hassle-free experience."
    },
    {
      "name": "Tirupati Balaji Darshan Tour Package From Pune",
      "description": "Amruta Travels offers a special Tirupati Balaji Darshan Tour Package from Pune. Our package includes direct bus transport, fast darshan arrangements, and a guided tour of the temple, ensuring a spiritual and peaceful journey for all devotees."
    },
    {
      "name": "Tirupati Balaji Tour Package From Pune by Bus",
      "description": "Embark on a divine trip to Tirupati Balaji with Amruta Travels. Our Tirupati Balaji tour package includes a comfortable bus ride, temple darshan, and sightseeing in the holy city, with all arrangements taken care of for a fulfilling religious experience."
    },
    {
      "name": "Pune to Hyderabad Volvo Sleeper Bus Hire",
      "description": "Travel in style and comfort with Amruta Travels’ Pune to Hyderabad Volvo Sleeper Bus Hire service. Ideal for long-distance travel, our Volvo sleeper buses offer spacious reclining seats, onboard entertainment, and refreshments, ensuring a comfortable journey to the city of pearls."
    },
    {
      "name": "Pune to Ramoji Film City Bus Package",
      "description": "Visit the world-renowned Ramoji Film City from Pune with our dedicated bus package. Amruta Travels offers comfortable buses with professional drivers, and the package includes both transport and entry to the film city for a fun and exciting day trip."
    },
    {
      "name": "Pune to Hyderabad Volvo Sleeper Bus for Trips",
      "description": "For a luxurious and relaxed travel experience, book our Pune to Hyderabad Volvo Sleeper Bus for Trips. This service is perfect for long-distance travel, offering comfort with its spacious sleeper compartments, AC facilities, and a safe journey to Hyderabad."
    },
    {
      "name": "Pune to Hyderabad Volvo Sleeper Bus on Rent",
      "description": "Amruta Travels offers Volvo sleeper buses for rent from Pune to Hyderabad. Whether you're planning a family trip, corporate outing, or group travel, our Volvo buses provide a premium travel experience with ample space, reclining seats, and modern amenities."
    },
    {
      "name": "Pune to Hyderabad Volvo Sleeper Bus on Rent Contact Number",
      "description": "For booking a Volvo sleeper bus from Pune to Hyderabad, contact Amruta Travels. We provide hassle-free booking services and offer well-maintained Volvo buses for rent, ensuring a comfortable and safe journey for all passengers."
    },
    {
      "name": "Sleeper Coach Bus on Rent in Pune",
      "description": "Book a sleeper coach bus on rent in Pune with Amruta Travels. Our sleeper coaches are equipped with comfortable, reclining seats, air conditioning, and on-board entertainment, ensuring a comfortable journey for long-distance trips."
    },
    {
      "name": "Volvo Bus on Rent in Pune",
      "description": "Amruta Travels offers premium Volvo buses for rent in Pune. Ideal for long journeys and group trips, our Volvo buses provide superior comfort, air conditioning, and excellent amenities for a seamless travel experience."
    },
    {
      "name": "Pune to Buddha Statue Hyderabad Bus Service",
      "description": "Explore the iconic Buddha Statue in Hyderabad with Amruta Travels’ dedicated bus service from Pune. Our buses ensure a comfortable, safe, and timely journey to one of Hyderabad’s most prominent landmarks, offering great views along the way."
    }
  ],
  "tableData": [
    ["Pune to Mysore Ooty Bus Package on Rent", "Pune to Tirupati Balaji Bus on Hire"],
    ["Pune to Tirupati Bus Package", "Tirupati Balaji Darshan Tour Package From Pune"],
    ["Tirupati Balaji Tour Package From Pune by Bus", "Pune to Hyderabad Volvo Sleeper Bus Hire"],
    ["Pune to Ramoji Film City Bus Package", "Pune to Hyderabad Volvo Sleeper Bus for Trips"],
    ["Pune to Hyderabad Volvo Sleeper Bus on Rent", "Pune to Hyderabad Volvo Sleeper Bus on Rent Contact Number"],
    ["Sleeper Coach Bus on Rent in Pune", "Volvo Bus on Rent in Pune"],
    ["Pune to Buddha Statue Hyderabad Bus Service", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Pune to Hyderabad Bus Rental with Amruta Travels",
    "WhyChoosedescription": "Amruta Travels offers premium bus rental services for Pune to Hyderabad travel, ideal for corporate trips, family tours, student groups, or event delegations. Our service provides a comfortable and hassle-free experience for the long intercity journey, with buses equipped for both daytime and overnight travel. Enjoy a relaxed ride with our professional transport solutions tailored to suit your group’s needs."
  },
  {
    "WhyChooseheading": "Perfect for Group Travel, Events, and Outstation Tours",
    "WhyChoosedescription": "Whether you’re traveling for a wedding in Hyderabad, a business convention, a college trip, or a family function, our Pune to Hyderabad bus rental service ensures timely, safe, and coordinated travel. We cater to one-way and round-trip plans with flexible pick-up and drop-off scheduling, customized as per your itinerary."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses for Long-Distance Comfort",
    "WhyChoosedescription": "Choose from our fleet of 17 to 50-seater AC and Non-AC buses, all designed for comfort during long-distance travel. Our buses include reclining seats, overhead storage, large luggage compartments, and optional entertainment systems, making the 8–10 hour journey from Pune to Hyderabad smooth and enjoyable for all age groups."
  },
  {
    "WhyChooseheading": "Experienced Intercity Drivers for Safe and Smooth Travel",
    "WhyChoosedescription": "Our drivers are skilled in long-distance highway travel and well-acquainted with the Pune–Solapur–Hyderabad route. They prioritize safety, follow route protocols, and are trained to ensure a peaceful journey. Whether it’s a night drive or an early morning start, your group is in safe hands throughout the trip."
  },
  {
    "WhyChooseheading": "Customizable Travel Itinerary and Multiple Pickup Points",
    "WhyChoosedescription": "Amruta Travels allows complete flexibility in planning your Pune to Hyderabad trip. Set your own travel time, route, and rest stops. Need pickups from multiple points in Pune or scheduled drop-offs in Hyderabad? We accommodate your group’s unique travel plans with complete coordination and support."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing for Pune to Hyderabad bus hire is competitive and transparent. The package includes fuel, tolls, driver fees, and taxes, so you can plan your budget confidently. We also offer flexible payment options for large group bookings, tours, and institutional travel plans."
  },
  {
    "WhyChooseheading": "Clean, Sanitized Buses with Modern Amenities",
    "WhyChoosedescription": "All our buses are cleaned and sanitized before every trip, and we perform regular maintenance checks to ensure a safe and hygienic experience. Features like air-conditioning, clean upholstery, and working lights are guaranteed—especially important for long, overnight journeys."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and 24/7 Customer Assistance",
    "WhyChoosedescription": "Booking your Pune to Hyderabad bus is simple through our website, phone, or in-person. Our dedicated support team helps plan the route, offers vehicle suggestions, and assists with real-time updates. We remain available 24/7 to assist you during the trip for any changes or support needs."
  }
]


















    }

const faqData = [
  {
    question: 'Can I rent a bus from Pune to Hyderabad?',
    answer: 'Yes, Amruta Travels offers intercity bus rental services from Pune to Hyderabad. Whether it’s a family tour, corporate event, or group travel, we provide reliable and comfortable transportation solutions.',
  },
  {
    question: 'What types of buses are available for Pune to Hyderabad travel?',
    answer: 'We provide a range of buses including 32, 35, 40, 45, and 50-seater AC and non-AC coaches. Luxury and sleeper options are also available for long-distance travel.',
  },
  {
    question: 'How long does it take to travel from Pune to Hyderabad by bus?',
    answer: 'The travel time from Pune to Hyderabad by bus is approximately 10 to 12 hours, depending on traffic, road conditions, and rest breaks during the journey.',
  },
  {
    question: 'Is a round trip option available for Pune to Hyderabad bus rental?',
    answer: 'Yes, we offer both one-way and round-trip bus rental services. You can customize your return date and time as per your travel plans.',
  },
  {
    question: 'Are your buses suitable for overnight journeys?',
    answer: 'Absolutely. Our long-distance buses come with push-back seats, ample legroom, and luggage space. We also offer sleeper coaches and luxury AC buses ideal for overnight travel.',
  },
  {
    question: 'Do the drivers have intercity travel experience?',
    answer: 'Yes, all our drivers are experienced in long-distance routes and are well-versed with Pune to Hyderabad highway conditions, ensuring a safe and smooth journey.',
  },
  {
    question: 'Can I include sightseeing stops along the way?',
    answer: 'Yes, based on your schedule, we can include custom halts or sightseeing stops. Just let us know your requirements in advance.',
  },
  {
    question: 'What are the charges for renting a bus from Pune to Hyderabad?',
    answer: 'The cost depends on the type of bus, one-way or round trip, and any additional services. Contact us with your travel details for a transparent and personalized quote.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Hyderabad bus rental?',
    answer: 'Amruta Travels offers clean, well-maintained buses, trained drivers, flexible booking options, and excellent customer support. We ensure your long journey is safe, timely, and comfortable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Suresh Iyer',
    role: 'Corporate Event Manager',
    text: 'We hired a bus from Pune to Hyderabad for our corporate offsite. The bus was punctual, clean, and the driver was very professional. We had a smooth and hassle-free journey with Amruta Travels.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Raut',
    role: 'Family Group Organizer',
    text: 'Our family trip to Hyderabad was made so comfortable by Amruta Travels. The 40-seater bus was well-equipped for a long journey and the driver was friendly and cooperative. Highly recommended!',
    rating: 5,
  },
];


































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hyderabad Bus On Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-hyderabad-bus-on-rent.jpg",
  "description": "Book a comfortable and luxurious bus for your trip from Pune to Hyderabad with Amruta Travels. Choose from Volvo Sleeper buses and other coach options for a smooth and safe journey. We offer bus packages for popular destinations like Ramoji Film City, Buddha Statue, Tirupati, and Mysore-Ooty.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3450"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999", // Adjust price based on specific trip package
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-hyderabad-bus-on-rent"
  }
};




    return (
        <div>



<Helmet>
  <title>Call: +91 7353109555 | Pune to Hyderabad Bus On Rent | Volvo Sleeper Bus, Ramoji Film City | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a Volvo Sleeper bus from Pune to Hyderabad with Amruta Travels. Comfortable buses for trips to Ramoji Film City, Buddha Statue, Tirupati, and more. Affordable prices, reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetohyderbadbus;